module.exports = __webpack_public_path__ + "vanuatu.svg?1c3366c8ab51c2a0494dbce820687d10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/vanuatu.svg
// module id = 336
// module chunks = 10